/* ==========================================================================
   a11y.js — keyboard accessibility for this theme
   --------------------------------------------------------------------------
   Plain JavaScript. No Liquid. Shopify serves this file as-is, so nothing
   here can be broken by template parsing.

   INSTALL
     1. assets/a11y.js   <- this file
     2. In layout/theme.liquid, before </body>:
          <script src="{{ 'a11y.js' | asset_url }}" defer></script>

   WHAT IT DOES
     Tab      moves between top-level items and skips over submenus
     ArrowDown / ArrowUp   enters and walks inside an open submenu
     Enter    follows the link as normal
     Escape   leaves the submenu and returns focus to the parent item
     Also: visible focus ring, skip link, add-to-cart announcement + focus
     into the cart drawer, and a small keyboard hint panel.

   CONFIG is at the top. Set DEBUG to true to see what it matched.
   ========================================================================== */

(function () {
  'use strict';

  var CONFIG = {
    DEBUG: true,

    submenu: '.list-menu-dropdown, .menu-drawer__submenu, .mega-menu__content',
    quickAdd: '.card__quick-add, .quick-add__button, button[name="add"]',
    productCard: '.card, .product-card, .card-wrapper',
    cartDrawer: 'cart-drawer, #CartDrawer, .cart-drawer, .drawer--cart',
    cartClose: '.drawer__close, .cart-drawer__close, [data-cart-close]',

    skipText: 'דלג לתוכן הראשי',
    skipTarget: '#MainContent, main, [role="main"]',
    addedText: 'המוצר נוסף לעגלה',
    closeCartText: 'סגירת עגלת הקניות',

    headerHeight: 120,
    focusColor: '#000',
    hintMinWidth: 1024,
    hintSecondsEach: 2.8,
    hintCycles: 2
  };

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function log() {
    if (!CONFIG.DEBUG) return;
    console.log.apply(console, ['[a11y]'].concat([].slice.call(arguments)));
  }

  function all(sel, root) {
    try { return [].slice.call((root || document).querySelectorAll(sel)); }
    catch (e) { return []; }
  }

  function visible(el) {
    if (!el) return false;
    var s = getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden' || s.opacity === '0') return false;
    return el.offsetParent !== null || s.position === 'fixed';
  }

  /* ---- CSS, injected from JS so there is no separate stylesheet --------- */
  function injectStyles() {
    var css = [
      ':focus-visible{outline:3px solid ' + CONFIG.focusColor + ';outline-offset:2px}',
      '*{scroll-margin-top:' + CONFIG.headerHeight + 'px}',
      '.a11y-sr{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;white-space:nowrap!important}',
      '.a11y-skip{position:fixed;top:-200px;left:16px;z-index:2147483647;padding:12px 20px;background:#fff;color:#000;font-size:15px;font-weight:600;text-decoration:none;border:2px solid #000;border-radius:6px;transition:top .15s}',
      '.a11y-skip:focus{top:16px}',
      CONFIG.productCard + ':focus-within ' + CONFIG.quickAdd.split(',')[0] + '{opacity:1!important;visibility:visible!important;pointer-events:auto!important}',
      '#a11y-hint{display:none}',
      '@media (min-width:' + CONFIG.hintMinWidth + 'px) and (hover:hover) and (pointer:fine){',
      '#a11y-hint{display:block;position:fixed;left:20px;bottom:20px;width:120px;height:120px;z-index:2147483000;box-sizing:border-box;padding:8px 7px 7px;border-radius:14px;background:#16181d;color:#fff;border:1px solid rgba(255,255,255,.14);box-shadow:0 8px 28px rgba(0,0,0,.32);text-align:center;cursor:pointer;opacity:0;transform:translateY(10px) scale(.94);transition:opacity .28s,transform .28s cubic-bezier(.2,.9,.3,1.3);pointer-events:none;direction:rtl;font-family:inherit}',
      '#a11y-hint.on{opacity:1;transform:none;pointer-events:auto}}',
      '#a11y-hint .stage{position:relative;width:100%;height:62px}',
      '#a11y-hint .scene{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .3s}',
      '#a11y-hint[data-s="tab"] .s-tab,#a11y-hint[data-s="arrow"] .s-arrow,#a11y-hint[data-s="enter"] .s-enter,#a11y-hint[data-s="esc"] .s-esc{opacity:1}',
      '#a11y-hint .lbl{margin:4px 0 0;font-size:10.5px;line-height:1.3;font-weight:600;color:rgba(255,255,255,.92)}',
      '#a11y-hint .lbl b{display:block;font-size:11.5px;font-weight:700;color:#fff}',
      '#a11y-hint .key{fill:#2b2f38;stroke:rgba(255,255,255,.22)}',
      '#a11y-hint .hot{fill:#4f7cf7;stroke:#7ea0ff}',
      '#a11y-hint .item{fill:#3a3f4b}',
      '#a11y-hint .ring{fill:none;stroke:#4f7cf7;stroke-width:2}',
      '#a11y-hint .grp{fill:none;stroke:rgba(255,255,255,.16);stroke-dasharray:2 2}',
      '#a11y-hint .txt{fill:#fff;font-size:8px;font-weight:700;text-anchor:middle;dominant-baseline:middle;font-family:system-ui,sans-serif}',
      '@keyframes a11yHop{0%,14%{transform:translateX(0)}28%,42%{transform:translateX(-24px)}56%,70%{transform:translateX(-48px)}84%,100%{transform:translateX(0)}}',
      '#a11y-hint .s-tab .ring{animation:a11yHop 2.8s infinite}',
      '@keyframes a11yWalk{0%,18%{transform:translateY(0)}32%,50%{transform:translateY(13px)}64%,82%{transform:translateY(26px)}96%,100%{transform:translateY(0)}}',
      '#a11y-hint .s-arrow .ring{animation:a11yWalk 2.8s infinite}',
      '@keyframes a11yPress{0%,34%,66%,100%{transform:translateY(0)}46%,54%{transform:translateY(3px)}}',
      '#a11y-hint .s-enter .press,#a11y-hint .s-esc .press{animation:a11yPress 2.8s infinite}',
      '@media (prefers-reduced-motion:reduce){#a11y-hint,#a11y-hint *{animation:none!important;transition:none!important}}'
    ].join('');

    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  /* ====================================================================== */
  /* 1. MENUS — Tab skips submenus, arrows go inside                        */
  /* ====================================================================== */

  // Take a subtree out of the Tab order without blocking mouse clicks.
  // (`inert` would also kill pointer events and break hover menus.)
  function setTabbable(box, on) {
    all(FOCUSABLE + ',[tabindex]', box).forEach(function (el) {
      if (on) {
        if (!el.hasAttribute('data-a11y-ti')) return;
        var prev = el.getAttribute('data-a11y-ti');
        if (prev === '') el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', prev);
        el.removeAttribute('data-a11y-ti');
      } else {
        if (el.hasAttribute('data-a11y-ti')) return;
        el.setAttribute('data-a11y-ti', el.getAttribute('tabindex') || '');
        el.setAttribute('tabindex', '-1');
      }
    });
  }

  function initMenus() {
    // The theme gives its <li> elements no class, so find a parent by the
    // fact that it directly owns a submenu.
    var parents = all('nav li, header li, .header li, .menu-drawer li').filter(function (li) {
      var sub = li.querySelector(CONFIG.submenu);
      return sub && sub.closest('li') === li;
    });

    log('menu parents:', parents.length);

    parents.forEach(function (li) {
      if (li.hasAttribute('data-a11y-menu')) return;
      li.setAttribute('data-a11y-menu', '1');

      var sub = li.querySelector(CONFIG.submenu);
      var trigger = li.querySelector('a, button, summary');
      if (!sub || !trigger) return;

      var details = li.querySelector('details') || li.closest('details');
      var hidClass = false;
      var syncing = false;

      setTabbable(sub, false);
      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-expanded', 'false');

      function open(byTheme) {
        setTabbable(sub, true);
        trigger.setAttribute('aria-expanded', 'true');
        if (!byTheme) {
          if (sub.classList.contains('hidden')) {
            sub.classList.remove('hidden');
            hidClass = true;
          }
          if (details && !details.open) { syncing = 1; details.open = true; syncing = 0; }
        }
      }

      function close(byTheme) {
        setTabbable(sub, false);
        trigger.setAttribute('aria-expanded', 'false');
        if (!byTheme) {
          if (hidClass) { sub.classList.add('hidden'); hidClass = false; }
          if (details && details.open) { syncing = 1; details.open = false; syncing = 0; }
        }
      }

      // Follow the theme when it opens the panel itself, so links inside the
      // mobile drawer never end up stuck outside the Tab order.
      if (details) {
        details.addEventListener('toggle', function () {
          if (syncing) return;
          if (details.open) open(true); else close(true);
        });
      }

      trigger.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown') return;
        e.preventDefault();
        open(false);
        var first = all(FOCUSABLE, sub).filter(visible)[0];
        if (first) first.focus();
      });

      sub.addEventListener('keydown', function (e) {
        var items = all(FOCUSABLE, sub).filter(visible);
        var i = items.indexOf(document.activeElement);

        if (e.key === 'Escape') {
          e.preventDefault(); close(false); trigger.focus();
        } else if (e.key === 'ArrowDown' && i > -1) {
          e.preventDefault(); (items[i + 1] || items[0]).focus();
        } else if (e.key === 'ArrowUp' && i > -1) {
          e.preventDefault(); (items[i - 1] || items[items.length - 1]).focus();
        } else if (e.key === 'Home') {
          e.preventDefault(); if (items[0]) items[0].focus();
        } else if (e.key === 'End') {
          e.preventDefault(); if (items.length) items[items.length - 1].focus();
        }
      });

      li.addEventListener('focusout', function (e) {
        if (!li.contains(e.relatedTarget)) close(false);
      });
    });

    // Left/right between top-level items. RTL flips these.
    var rtl = getComputedStyle(document.documentElement).direction === 'rtl';
    var nextKey = rtl ? 'ArrowLeft' : 'ArrowRight';
    var prevKey = rtl ? 'ArrowRight' : 'ArrowLeft';

    var top = parents.filter(function (li) {
      return !(li.parentElement && li.parentElement.closest('li'));
    });

    top.forEach(function (li) {
      var trigger = li.querySelector('a, button, summary');
      if (!trigger || trigger.hasAttribute('data-a11y-h')) return;
      trigger.setAttribute('data-a11y-h', '1');

      trigger.addEventListener('keydown', function (e) {
        if (e.key !== nextKey && e.key !== prevKey) return;
        var list = top.map(function (x) { return x.querySelector('a, button, summary'); })
                      .filter(Boolean).filter(visible);
        var i = list.indexOf(trigger);
        if (i < 0) return;
        e.preventDefault();
        (e.key === nextKey ? (list[i + 1] || list[0])
                           : (list[i - 1] || list[list.length - 1])).focus();
      });
    });
  }

  /* ====================================================================== */
  /* 2. QUICK ADD — reachable by Tab                                        */
  /* ====================================================================== */
  function initQuickAdd() {
    var buttons = all(CONFIG.quickAdd);
    log('quick-add controls:', buttons.length);

    buttons.forEach(function (el) {
      if (el.hasAttribute('data-a11y-qa')) return;
      el.setAttribute('data-a11y-qa', '1');

      if (el.getAttribute('tabindex') === '-1') el.removeAttribute('tabindex');

      var tag = el.tagName.toLowerCase();
      var isButton = tag === 'button' || (tag === 'input' && /submit|button/i.test(el.type));
      var isLink = tag === 'a' && el.hasAttribute('href');

      if (!isButton && !isLink) {
        if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); el.click(); }
        });
      }
    });
  }

  /* ====================================================================== */
  /* 3. CART — announce, move focus in, trap, return focus                  */
  /* ====================================================================== */
  var live, cartTrigger = null, openDrawer = null;

  function announce(text) {
    if (!live) return;
    // Clearing first is required, or a screen reader stays silent when the
    // same product is added twice.
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 100);
    setTimeout(function () { live.textContent = ''; }, 4000);
  }

  function fixCloseButton(drawer) {
    var btn = drawer.querySelector(CONFIG.cartClose);
    if (!btn || btn.hasAttribute('data-a11y-close')) return btn;
    btn.setAttribute('data-a11y-close', '1');

    if (btn.tagName.toLowerCase() !== 'button') {
      if (!btn.hasAttribute('role')) btn.setAttribute('role', 'button');
      btn.setAttribute('tabindex', '0');
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); btn.click(); }
      });
    } else if (btn.getAttribute('tabindex') === '-1') {
      btn.removeAttribute('tabindex');
    }

    if (!btn.textContent.trim() && !btn.getAttribute('aria-label')) {
      btn.setAttribute('aria-label', CONFIG.closeCartText);
    }
    all('svg,img', btn).forEach(function (i) { i.setAttribute('aria-hidden', 'true'); });
    return btn;
  }

  function trapKeys(e) {
    if (!openDrawer) return;

    if (e.key === 'Escape') {
      var btn = openDrawer.querySelector(CONFIG.cartClose);
      if (btn) btn.click();
      endTrap();
      return;
    }
    if (e.key !== 'Tab') return;

    var items = all(FOCUSABLE, openDrawer).filter(visible);
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];

    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function endTrap() {
    if (!openDrawer) return;
    document.removeEventListener('keydown', trapKeys, true);
    openDrawer = null;
    if (cartTrigger && document.body.contains(cartTrigger)) {
      var t = cartTrigger;
      setTimeout(function () { t.focus(); }, 50);
    }
    cartTrigger = null;
  }

  function cartAdded(trigger) {
    announce(CONFIG.addedText);
    cartTrigger = (trigger && trigger !== document.body) ? trigger : null;
    log('cart add detected');

    var stop = Date.now() + 3000;
    var poll = setInterval(function () {
      var drawer = all(CONFIG.cartDrawer).filter(visible)[0];
      if (drawer) {
        clearInterval(poll);
        openDrawer = drawer;
        document.addEventListener('keydown', trapKeys, true);

        var btn = fixCloseButton(drawer);
        var target = (btn && visible(btn)) ? btn : all(FOCUSABLE, drawer).filter(visible)[0];
        if (target) target.focus();

        var watch = setInterval(function () {
          if (!document.body.contains(drawer) || !visible(drawer)) {
            clearInterval(watch);
            endTrap();
          }
        }, 300);
      } else if (Date.now() > stop) {
        clearInterval(poll);
        log('no cart drawer appeared');
      }
    }, 120);
  }

  function initCart() {
    live = document.createElement('div');
    live.className = 'a11y-sr';
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');
    document.body.appendChild(live);

    var isAdd = function (u) { return /\/cart\/add/.test(String(u || '')); };

    // Intercepting the request works no matter which script or app fires it.
    var origFetch = window.fetch;
    if (origFetch) {
      window.fetch = function () {
        var args = [].slice.call(arguments);
        var url = (args[0] && args[0].url) ? args[0].url : args[0];
        var watching = isAdd(url);
        var trigger = watching ? document.activeElement : null;
        return origFetch.apply(this, args).then(function (r) {
          if (watching && r && r.ok) cartAdded(trigger);
          return r;
        });
      };
    }

    var xo = XMLHttpRequest.prototype.open;
    var xs = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this._a11yUrl = u; return xo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      if (isAdd(this._a11yUrl)) {
        var trigger = document.activeElement, x = this;
        x.addEventListener('load', function () {
          if (x.status >= 200 && x.status < 300) cartAdded(trigger);
        });
      }
      return xs.apply(this, arguments);
    };

    // Some apps submit a plain form instead of using fetch or XHR.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && /\/cart\/add/.test(form.getAttribute('action') || '')) {
        cartAdded(document.activeElement);
      }
    }, true);
  }

  /* ====================================================================== */
  /* 4. SLIDER LABELS                                                       */
  /* ====================================================================== */
  function initSliderLabels() {
    var n = 0;
    all('[aria-label]').forEach(function (el) {
      var label = (el.getAttribute('aria-label') || '').trim();
      if (!/^(view|go to)?\s*slide\b|^slide\s*\d*$/i.test(label)) return;
      if (!el.textContent.trim()) return;  // icon-only dot, leave it
      el.removeAttribute('aria-label');
      n++;
    });
    if (n) log('slider labels cleaned:', n);
  }

  /* ====================================================================== */
  /* 5. SKIP LINK                                                           */
  /* ====================================================================== */
  function initSkipLink() {
    var target = document.querySelector(CONFIG.skipTarget);
    if (!target) { log('skip link: no target'); return; }
    if (!target.id) target.id = 'a11y-main';
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');

    var link = document.createElement('a');
    link.className = 'a11y-skip';
    link.href = '#' + target.id;
    link.textContent = CONFIG.skipText;
    link.addEventListener('click', function () {
      setTimeout(function () { target.focus(); }, 0);
    });

    document.body.insertBefore(link, document.body.firstChild);
    log('skip link ready');
  }

  /* ====================================================================== */
  /* 6. HINT PANEL                                                          */
  /* ====================================================================== */
  function initHint() {
    var KEY = 'a11y-hint-seen';
    var force = null;
    try { force = new URLSearchParams(location.search).get('a11yhint'); } catch (e) {}

    if (force === '0') { try { localStorage.removeItem(KEY); } catch (e) {} }

    var seen = false;
    if (force !== '1' && force !== '0') {
      try { seen = localStorage.getItem(KEY) === '1'; } catch (e) {}
    }

    var svg = function (inner) {
      return '<svg width="104" height="56" viewBox="0 0 104 56" aria-hidden="true" focusable="false">' + inner + '</svg>';
    };

    var panel = document.createElement('div');
    panel.id = 'a11y-hint';
    panel.setAttribute('aria-hidden', 'true');
    panel.setAttribute('role', 'presentation');
    panel.setAttribute('data-s', 'tab');
    panel.innerHTML =
      '<div class="stage">' +
        '<div class="scene s-tab">' + svg(
          '<rect class="item" x="76" y="6" width="20" height="9" rx="2"/>' +
          '<rect class="item" x="52" y="6" width="20" height="9" rx="2"/>' +
          '<rect class="item" x="28" y="6" width="20" height="9" rx="2"/>' +
          '<rect class="grp" x="50" y="20" width="24" height="26" rx="3"/>' +
          '<rect class="item" x="54" y="24" width="16" height="5" rx="1.5" opacity=".6"/>' +
          '<rect class="item" x="54" y="32" width="16" height="5" rx="1.5" opacity=".6"/>' +
          '<rect class="item" x="54" y="40" width="16" height="5" rx="1.5" opacity=".6"/>' +
          '<rect class="ring" x="74" y="4" width="24" height="13" rx="3"/>') + '</div>' +
        '<div class="scene s-arrow">' + svg(
          '<rect class="key" x="8" y="17" width="15" height="15" rx="3"/>' +
          '<path d="M15.5 27.5l-3-4h6z" fill="#fff"/>' +
          '<rect class="key" x="8" y="34" width="15" height="15" rx="3"/>' +
          '<path d="M15.5 38.5l3 4h-6z" fill="#fff"/>' +
          '<rect class="grp" x="38" y="8" width="56" height="42" rx="3"/>' +
          '<rect class="item" x="43" y="13" width="46" height="8" rx="2"/>' +
          '<rect class="item" x="43" y="26" width="46" height="8" rx="2"/>' +
          '<rect class="item" x="43" y="39" width="46" height="8" rx="2"/>' +
          '<rect class="ring" x="41" y="11" width="50" height="12" rx="3"/>') + '</div>' +
        '<div class="scene s-enter">' + svg(
          '<g class="press"><rect class="key hot" x="26" y="18" width="52" height="20" rx="4"/>' +
          '<text class="txt" x="52" y="29">Enter</text></g>') + '</div>' +
        '<div class="scene s-esc">' + svg(
          '<g class="press"><rect class="key" x="32" y="18" width="40" height="20" rx="4"/>' +
          '<text class="txt" x="52" y="29">Esc</text></g>' +
          '<path d="M76 28h10m-4-4l4 4-4 4" stroke="rgba(255,255,255,.5)" stroke-width="1.5" fill="none" stroke-linecap="round"/>') + '</div>' +
      '</div><p class="lbl"></p>';

    document.body.appendChild(panel);

    var label = panel.querySelector('.lbl');
    var tips = [
      { s: 'tab',   t: 'Tab',   d: 'לפריט הבא' },
      { s: 'arrow', t: 'חצים',  d: 'בתוך תפריט' },
      { s: 'enter', t: 'Enter', d: 'לבחירה' },
      { s: 'esc',   t: 'Esc',   d: 'ליציאה' }
    ];
    var i = 0, timer = null, shown = false;

    function draw() {
      var tip = tips[i % tips.length];
      panel.setAttribute('data-s', tip.s);
      label.innerHTML = '<b>' + tip.t + '</b>' + tip.d;
    }

    function hide() {
      clearInterval(timer);
      panel.classList.remove('on');
      if (force !== '1') { try { localStorage.setItem(KEY, '1'); } catch (e) {} }
      document.removeEventListener('keydown', dismiss, true);
    }

    function dismiss(e) { if (e.key === 'Escape') hide(); }

    function show() {
      if (shown) return;
      if (!matchMedia('(min-width:' + CONFIG.hintMinWidth + 'px) and (hover:hover) and (pointer:fine)').matches) return;
      shown = true;
      draw();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { panel.classList.add('on'); });
      });
      timer = setInterval(function () {
        i++;
        if (i >= tips.length * CONFIG.hintCycles) { hide(); return; }
        draw();
      }, CONFIG.hintSecondsEach * 1000);
      document.addEventListener('keydown', dismiss, true);
      panel.addEventListener('click', hide);
    }

    log('hint ready. seen =', seen);

    if (force === '1') { show(); return; }
    if (seen) return;

    var onTab = function (e) {
      if (e.key !== 'Tab') return;
      document.removeEventListener('keydown', onTab);
      show();
    };
    document.addEventListener('keydown', onTab);
  }

  /* ====================================================================== */
  /* ALT TEXT AUDIT — run a11yAuditImages() in the console                  */
  /* ====================================================================== */
  window.a11yAuditImages = function () {
    var rows = [];
    all('img').forEach(function (img) {
      var alt = img.getAttribute('alt');
      var file = (img.currentSrc || img.src || '').split('?')[0].split('/').pop();
      var problem = null;
      if (alt === null) problem = 'no alt attribute';
      else if (!alt.trim()) problem = 'empty alt (fine only if decorative)';
      if (problem) rows.push({ problem: problem, file: file, width: img.naturalWidth });
    });
    console.table(rows);
    console.log('Fix these in Shopify admin > Content > Files.');
    return rows;
  };

  /* ====================================================================== */
  /* BOOT                                                                   */
  /* ====================================================================== */
  function rescan() {
    initMenus();
    initQuickAdd();
    initSliderLabels();
  }

  function start() {
    injectStyles();
    initSkipLink();
    initCart();
    rescan();
    initHint();

    // Menus and product cards re-render on section reload and on AJAX paging.
    var pending;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(rescan, 250);
    }).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', rescan);

    log('ready');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
